import { useTranslation } from 'react-i18next';

export default function useYupValidationTranslations() {
  const { t, i18n } = useTranslation(['validation']);

  const getTranslation = (key, params = {}) => {
    return t(key, {
      ns: 'validation',
      ...params,
    });
  };

  const existsTranslation = (key) => {
    if (i18n.exists(key, { ns: 'validation' })) {
      return key;
    }
    return null;
  };

  const translateError = (error) => {
    const { type, message } = error || {};

    const key = message?.key || existsTranslation(message) || type;

    return getTranslation(key, { value: message?.value });
  };

  return translateError;
}
